import { ConfigState } from './types';

export const envName = (state: ConfigState): string => {
  return state.name;
};
